var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { constructGallery } from './constructGallery';
import Image from '@jetshop/ui/Image/Image';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
const wrapperStyles = "w1q8fgc2";
const Overlay = /*#__PURE__*/styled('div')({
  name: "Overlay",
  class: "o1aaxga1"
});

const Gallery = function Gallery(props) {
  const {
    sizes = [1, 1, 1, 1 / 2, 1 / 2],
    fullScreenSizes = [1, 1, 1, 1],
    thumbnailSizes = ['5rem'],
    aspect = '1:1',
    thumbnailPosition = 'bottom',
    backgroundColor = 'white',
    thumbnailQuality,
    quality,
    images,
    galleryRef,
    eagerlyLoad = [0]
  } = props,
        rest = __rest(props, ["sizes", "fullScreenSizes", "thumbnailSizes", "aspect", "thumbnailPosition", "backgroundColor", "thumbnailQuality", "quality", "images", "galleryRef", "eagerlyLoad"]);

  const {
    theme: {
      breakpoints
    }
  } = useShopConfig();
  const {
    selectedChannel
  } = React.useContext(ChannelContext);
  const baseUrl = (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.url) ? String(selectedChannel.url) : null;
  const [isFullscreen, setFullscreen] = React.useState(false);
  const galleryImages = React.useMemo(() => constructGallery(images, fullScreenSizes, aspect, baseUrl, breakpoints), [aspect, baseUrl, breakpoints, fullScreenSizes, images]);
  return React.createElement("div", {
    className: wrapperStyles,
    style: {
      ['--slide-bg']: backgroundColor
    }
  }, React.createElement(ImageGallery, Object.assign({
    ref: r => galleryRef ? galleryRef.current = r : null,
    thumbnailPosition: thumbnailPosition,
    items: galleryImages,
    autoPlay: false,
    showPlayButton: false,
    showThumbnails: galleryImages.length > 1,
    useBrowserFullscreen: false,
    preventDefaultTouchmoveEvent: isFullscreen,
    onScreenChange: el => setFullscreen(!!el),
    renderItem: item => {
      return React.createElement("div", {
        className: "image-gallery-image"
      }, isFullscreen ? React.createElement("img", {
        src: item.original,
        alt: item.originalAlt,
        srcSet: item.srcSet,
        sizes: item.sizes,
        title: item.originalTitle
      }) : React.createElement(React.Fragment, null, React.createElement(Image, {
        src: item.original,
        alt: item.originalAlt,
        sizes: sizes,
        title: item.originalTitle,
        aspect: aspect,
        quality: quality,
        modifiedDate: item.modifiedDate,
        critical: eagerlyLoad.includes(item.index)
      }), props.children && React.createElement(Overlay, null, props.children)));
    },
    renderThumbInner: item => {
      return React.createElement("div", {
        className: "image-gallery-thumbnail-inner"
      }, React.createElement(Image, {
        src: item.thumbnail,
        alt: item.thumbnailAlt,
        title: item.thumbnailTitle,
        sizes: thumbnailSizes,
        aspect: aspect,
        quality: thumbnailQuality
      }), item.thumbnailLabel && React.createElement("div", {
        className: "image-gallery-thumbnail-label"
      }, item.thumbnailLabel));
    }
  }, rest)));
};

export default Gallery;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Gallery/Gallery.linaria.css");